import { userConstants } from "../../store/actionTypes";

const initState = {
  // profile: false,
  isProfileUpdated: false,
  isPwdChanged: false,
  isForgetPwd: false,
  isReset: false,
  tickerData: false,
  subscription: null,
  user: null,
  countries: [],
  cities: [],
  setTourGuide: true,
};
let count;
let setTourGuide;
let user;

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case userConstants.INITIALIZE_GUIDED_TOUR:
      user = JSON.parse(localStorage.getItem("user"));
      count = parseInt(localStorage.getItem("localTourGuide"));
      localStorage.setItem("localTourGuide", count + 1);
      setTourGuide = user.login_count <= 1 && count < 2 ? action.state : false;
      count = state.localTourGuide;
      return {
        ...state,
        setTourGuide: setTourGuide,
      };
    case userConstants.STATE_GUIDED_TOUR:
      user = JSON.parse(localStorage.getItem("user"));
      count = parseInt(localStorage.getItem("localTourGuide"));
      if (action.state === false) {
        localStorage.setItem("localTourGuide", count + 1);
      }
      return {
        ...state,
        setTourGuide: action.state,
      };
    case userConstants.LOGIN_SUCCESS:
      localStorage.setItem("localTourGuide", 1);
      return {
        ...state,
        user: action.user.user,
        setTourGuide: action.user.user.login_count > 2 ? false : true,
        subscription: action.user.subscription_details,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        setTourGuide: false,
      };
    case userConstants.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        isProfileUpdated: true,
      };
    case userConstants.UPDATE_PROFILE_SUCCESS:
      const userObject = JSON.stringify(action.user);
      localStorage.setItem("user", userObject);
      return {
        ...state,
        isProfileUpdated: false,
        user: userObject,
      };
    case userConstants.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        isProfileUpdated: false,
      };
    //COUNTRY
    case userConstants.COUNTRY_REQUEST:
      return state;
    case userConstants.COUNTRY_SUCCESS:
      return {
        ...state,
        countries: action.response.responseObject,
        cities: action.response.data,
      };
    case userConstants.COUNTRY_FAILURE:
      return state;
    //Change Password
    case userConstants.CHANGE_PWD_REQUEST:
      return {
        ...state,
        isPwdChanged: true,
      };
    case userConstants.CHANGE_PWD_SUCCESS:
      return {
        ...state,
        isPwdChanged: false,
      };
    case userConstants.CHANGE_PWD_FAILURE:
      return {
        ...state,
        isPwdChanged: false,
      };
    //Forget Password
    case userConstants.FORGET_PWD_REQUEST:
      return {
        ...state,
        isForgetPwd: true,
      };
    case userConstants.FORGET_PWD_SUCCESS:
      return {
        ...state,
        isForgetPwd: false,
      };
    case userConstants.FORGET_PWD_FAILURE:
      return {
        ...state,
        isForgetPwd: false,
      };
    //Forget Password
    case userConstants.RESET_PWD_REQUEST:
      return {
        ...state,
        isReset: true,
      };
    case userConstants.RESET_PWD_SUCCESS:
      return {
        ...state,
        isReset: false,
      };
    case userConstants.RESET_PWD_FAILURE:
      return {
        ...state,
        isReset: false,
      };
    default:
      return state;
  }
};

export default userReducer;
